import React, { useState, useEffect } from "react";
import "./teams.css";
import Members from "../Shared/Members";
import { getAllUsers } from "../../Datahandler";

function sortByUsername(array) {
  return array.sort((a, b) => {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  });
}

const TeamGallery = () => {
  const [members, setMembers] = useState([]);
  useEffect(() => {
    getAllUsers().then((res) => {
      setMembers(res);
    });
  }, []);

  return (
    <div className="gallery-grid">
      <Members memberIds={members?.map((m) => m.userId)} />
    </div>
  );
};

export default TeamGallery;
